import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SimpleInput from '../SimpleInput';
import styles from './KeyValueRows.module.scss';
import { faMinusCircle, faPlusCircle, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { InfoTitle } from '../InfoTooltip';
import classNames from 'classnames';
import React from 'react';
import { isFirstItem, isLastItem } from '../../../utils/array';

export default function KeyValueRows(props) {
  return (
    <div className={styles.container}>
      <div className={styles.mapping_row_container}>
        <div className={styles.key_value_item}>
          {props.value.mappings.map((mapping, index, self) => (
            <React.Fragment key={index}>
              <div id={index} className={styles.mapping_row_item}>
                <div className={styles.mapping_row_item}>
                  <SimpleInput
                    value={mapping.key}
                    placeholder="key"
                    onChange={(e) => props.onMappingKeyChange(index, e.target.value)}
                  />{' '}
                  <span>
                    <FontAwesomeIcon icon={faArrowRight} />
                  </span>
                  <SimpleInput
                    value={mapping.value}
                    placeholder="value"
                    onChange={(e) => props.onMappingValueChange(index, e.target.value)}
                  />
                </div>
                <div className={styles.value_item_button_wrap}>
                  {!isFirstItem(index) && (
                    <InfoTitle content="Remove key-value pair">
                      <button className={styles.remove_button} onClick={(e) => props.onRemove(e, index)}>
                        <FontAwesomeIcon icon={faMinusCircle} />
                      </button>
                    </InfoTitle>
                  )}
                </div>
              </div>

              {isLastItem(index, self) && (
                <div id={index} key={index} className={classNames(styles.mapping_row_item, styles.add_row_item)}>
                  <button className={styles.add_button} onClick={props.onAddKeyValueRowClick}>
                    <FontAwesomeIcon icon={faPlusCircle} />
                    <span>Add additional key-value item</span>
                  </button>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
